export const ORDER_STATUS_NAMES = {
    0: 'Pending',
    1: 'Canceled',
    2: 'Confirmed',
};
